import React from 'react'
import { StyledInput } from './Inputs.styles';
import createInputWithValidation from './createInputWithValidation';


const PasswordInput = ({ name, value, onChange, onBlur, placeholder, isRequired, disabled }) => (
  <StyledInput
    id={name}
    name={name}
    value={value}
    onChange={onChange}
    type="password"
    onBlur={onBlur}
    placeholder={placeholder}
    required={isRequired}
    disabled={disabled}
  />
);

PasswordInput.defaultProps = {
  isRequired: false
};

export default createInputWithValidation('text')(PasswordInput);
